// Which body the admin page renders for a tab. Explicit tabs win over the plain-admin fallback:
// `isUserAdmin` is true for every LivableAdmin operator, so checking it first swallowed every staff
// tab after it and rendered the PM accounts grid under them.
const EXPLICIT = ['search', 'bill-queue', 'livy', 'pm-accounts', 'bill-automation'];
export const adminTabBody = (selectedTab, _ref) => {
  let isUserAdmin = _ref.isUserAdmin;
  if (EXPLICIT.includes(selectedTab)) return selectedTab;
  return isUserAdmin ? 'pm-accounts' : 'admin-accounts';
};